import numeral from 'numeral';

const keys = (isDark, t) => [
    {
        key: 'clicks',
        label: t('discover.author.chart.clicks'),
        icon: 'pagev-view',
        yAxisID: 'y3',
        img: isDark ? '/static/img/cursor-click-01_dark.svg' : '/static/img/cursor-click-01.svg',
    },
    {
        key: 'impressions',
        label: t('discover.author.chart.impressions'),
        icon: 'search',
        img: isDark ? '/static/img/file-search_dark.svg' : '/static/img/file-search.svg',
    },
    {
        key: 'ctr',
        label: t('discover.author.chart.ctr'),
        format: '0.00%',
        render: (data) => numeral(data * 100).format('0.00'),
        icon: 'ctr',
        yAxisID: 'y1',
        img: isDark ? '/static/img/cursor-box_dark.svg' : '/static/img/cursor-box.svg',
    },
    {
        label: t('discover.author.chart.pages'),
        key: 'pages',
        icon: 'clicks',
        yAxisID: 'y2',
        img: isDark ? '/static/img/file-05_dark.svg' : '/static/img/file-05.svg',
    },
];

export default keys;
